import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface profileType {
    profile: any
}
const initialState: profileType = {
    profile: null
}

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        handleAddProfile: (state, action: PayloadAction) => {
            state.profile = action.payload
        }
    }
})

export const { handleAddProfile } = profileSlice.actions
export default profileSlice.reducer